import React from 'react';
import PropTypes from 'prop-types';
import ButtonTertiary from '../ButtonTertiary';
import './styles.scss';

const ButtonTertiaryCompact = ({ classNames = [], ...props }) => (
    <ButtonTertiary {...props} classNames={['custom-btn-tertiary-compact', ...classNames]} />
);

ButtonTertiaryCompact.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
};

export default ButtonTertiaryCompact;
